import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserProgramSelectedChoicesRequestObjectSchema,
  GetUserProgramSelectedChoicesRequestObjectType,
  GetUserProgramSelectedChoicesResponseSchema,
  GetUserProgramSelectedChoicesResponseType
} from '../../../services/NwProductsExtensionsServices/APIService/types';

import { useNwProductsExtensionsService } from '../useNwProductsExtensionsService';

interface UseGetUserProgramSelectedChoicesApiInterface {
  getUserProgramSelectedChoicesApi: UseMutateAsyncFunction<
    GetUserProgramSelectedChoicesResponseType,
    Error,
    GetUserProgramSelectedChoicesRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserProgramSelectedChoicesApi =
  (): UseGetUserProgramSelectedChoicesApiInterface => {
    const { nwProductsExtensionsServiceInstance } =
      useNwProductsExtensionsService();

    const getUserProgramSelectedChoices = (
      requestObject: GetUserProgramSelectedChoicesRequestObjectType
    ) => {
      try {
        GetUserProgramSelectedChoicesRequestObjectSchema.parse(requestObject);
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwProductsExtensionsServiceInstance
        .getUserProgramSelectedChoices(requestObject)
        .then((response) => {
          try {
            GetUserProgramSelectedChoicesResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, error, status } = useMutation(
      getUserProgramSelectedChoices,
      {
        mutationKey: ['getUserProgramSelectedChoicesApi']
      }
    );

    return {
      getUserProgramSelectedChoicesApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetUserProgramSelectedChoicesApi };
